import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Container = styled.div`
  padding: 16px 12px;
  .hint {
    font-size: ${Variables.font_sizes.x1_medium};
    color: ${Variables.colors.complementary_700};
    line-height: 1.56;
    margin-bottom: 16px;
  }
`;

export const CardPanel = styled.div`
  padding: 16px 14px;
  margin-bottom: 24px;
  background-color: ${Variables.colors.complementary_50};
  box-shadow: 0 1px 6px 0 #ccc;
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    background-color: ${Variables.colors.complementary_200};
  }
  .top-row {
    display: flex;
    align-items: center;
    font-size: ${Variables.font_sizes.x2_medium};
    .role-icon {
      margin-left: 8px;

      &:before {
        font-size: 22px;
        color: ${Variables.colors.complementary_800};
      }
    }
    .panel-name {
      font-size: ${Variables.font_sizes.x1_medium};
      color: ${Variables.colors.complementary_800};
    }
  }
`;
